import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface NoCameraPermissionProps {
  modalState: UseModalState;
  onGoToSettings: () => void;
}

export function NoCameraPermission(props: NoCameraPermissionProps) {
  const { modalState, onGoToSettings } = props;

  return (
    <BottomSheet
      modalState={modalState}
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onGoToSettings}>
            Go to settings
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        title="Camera permission denied"
        description="We need camera access to take a photo of your badge. Please go to settings and give camera permissions"
        illustrationType="error"
      />
    </BottomSheet>
  );
}
